import React from 'react';
import { connect } from 'react-redux';
import { SlidesList } from './SlidesList';
import { AudioEditorControls } from '../audioEditor/menus/AudioEditorControls';
import properties from '../../constants/Properties';
import { setCurrentSlide, selectShape } from '../../actions/CurrentSlideActions';
import { updateCurrentSlide, changeMode, addSlide } from '../../actions/ProductionActions';
import storeManager from '../../store/StoreManager';
import { SlideMenu } from '../menus/SlideMenu';
import { MusicMenu } from './MusicMenu';
import { needsRefresh } from '../../actions/SlideViewerActions';
import modeType from '../../constants/ModeConstants';
import menuType from '../../constants/MenuType';
import { hideMenus } from '../../actions/MenuActions';
import saveManager from '../utils/SaveManager';
import { undoAction, redoAction } from '../utils/KeyboardShortcuts';
import zoomUtils from '../../components/utils/ZoomUtils';
import mouseUtils from '../../components/utils/MouseUtils';
import platformDetection from '../../components/utils/PlatformDetection';
import videoUtils from '../utils/VideoUtils';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import playController from '../utils/PlayController';
import hoverManager from '../utils/HoverManager';
import { refreshAudioTrack } from '../../actions/AudioEditorActions';
import audioToolUtils from '../audioTool/utils/AudioToolUtils';
import locales from '../../locales/LocalesManager';
import textEditorUtils from '../menus/textEditorTool/utils/TextEditorUtils';

export const SlideViewerContent = React.createClass({
    getInitialState () {
        return {
            isPreviewButtonOver: false,
            isAddButtonOver: false,
            isUndoOver: false,
            isRedoOver: false
        };
    },
    onPreviewButtonMouseIn() {
        hoverManager.show(this.refs.preview, 'preview');

        this.setState({
            isPreviewButtonOver: true
        });
    },
    onPreviewButtonMouseOut () {
        hoverManager.hide();

        this.setState({
            isPreviewButtonOver: false,
            isAddButtonOver: false
        });
    },
    onAddButtonMouseIn () {
        hoverManager.show(this.refs.addSlide, 'addSlide');

        this.setState({
            isAddButtonOver: true
        });
    },
    onAddButtonMouseOut () {
        hoverManager.hide();

        this.setState({
            isPreviewButtonOver: false,
            isAddButtonOver: false
        });
    },
    onUndoMouseIn() {
        hoverManager.show(this.refs.undo, 'undo');

        this.setState({
            isUndoOver: true
        });
    },
    onUndoMouseOut () {
        hoverManager.hide();

        this.setState({
            isUndoOver: false
        });
    },
    onRedoMouseIn() {
        hoverManager.show(this.refs.redo, 'redo');

        this.setState({
            isRedoOver: true
        });
    },
    onRedoMouseOut () {
        hoverManager.hide();

        this.setState({
            isRedoOver: false
        });
    },
    componentDidMount() {
        this.refs.slideViewerWrapper.addEventListener("click", this.onSlidesViewerClick);
        this.refs.slideViewerWrapper.addEventListener("touchend", this.onSlidesViewerClick);
    },
    componentWillReceiveProps: function(nextProps) {
        if (nextProps.needsRefresh == true)
            setTimeout(this.refreshView, 10);
    },
    refreshView () {
        //force renderer
        this.forceUpdate();

        const { dispatch } = this.props;
        dispatch(needsRefresh(false));
    },
    addNewSlide (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (playController.isPlaying)
            return;

        if (playController.isAudioEditorMode())
            playController.getOldScrollPosition();

        const state = storeManager.getState();
        const currentSlide = state.currentSlide;
        const currentIndex = currentSlide.currentSlideIndex;
        const { dispatch } = this.props;

        zoomUtils.closeZoom();

        dispatch(selectShape('slideFocus'));
        dispatch(updateCurrentSlide());
        dispatch(addSlide(currentIndex + 1));
        dispatch(setCurrentSlide(currentIndex + 1));
        audioEditorUtils.checkMarkerPositionForCurrentSlide();
        audioEditorUtils.checkTimelineWidth(true);

        this.refreshView();
        audioEditorUtils.addActionToHistory();
        saveManager.isContentChanged(true);
        dispatch(refreshAudioTrack(Math.random()));
    },
    changeMode (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        zoomUtils.closeZoom();

        if (playController.isAudioEditorAvailable()) {
            playController.changeMode();
        }

        videoUtils.updateStartPoint(false,true);

        const { dispatch } = this.props;
        dispatch(selectShape('slideFocus'));
        dispatch(updateCurrentSlide());
        dispatch(changeMode(modeType.PREVIEW));
        playController.closeAudioEditorMode();

        hoverManager.hide();
    },
    onSlidesViewerClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        var types = [menuType.CONTEXT_MENU, menuType.INSERT_MENU, menuType.SHAPE_MENU, menuType.UNIVERSES_MENU];

        if (e.target.className.indexOf('slideMenuButton') == -1)
            types.push(menuType.SLIDE_MENU);

        if (e.target.className.indexOf('eye') != -1 || e.target.className.indexOf('preview') != -1)
            mouseUtils.isCanvasAction = true;

        if (textEditorUtils.isTextEditorTool() && e.target.className.indexOf('undoRedo') != -1) // not hide text Editor menu when clicking on UNDO/REDO buttons
            return;

        this.props.dispatch(hideMenus(types));
    },
    onUndo (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (playController.isPlaying)
            return;

        if (textEditorUtils.isTextEditorTool()) { // the undo redo should be used for the text element when it has focus
            document.execCommand('undo', false, null);
            return;
        }

        zoomUtils.closeZoom();

        undoAction(this.props.dispatch);
    },
    onRedo (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (playController.isPlaying)
            return;

        if (textEditorUtils.isTextEditorTool()) { // the undo redo should be used for the text element when it has focus
            document.execCommand('redo', false, null);
            return;
        }

        zoomUtils.closeZoom();

        redoAction(this.props.dispatch);
    },
    isUndoAvailable() {
        if (textEditorUtils.isTextEditorTool()) // for text editing the undo/redo buttons should be always available
            return true;
        
        const undo = this.props.undo;

        if (undo && undo.length > 0)
            return true;
        else
            return false;
    },
    isRedoAvailable() {
        if (textEditorUtils.isTextEditorTool()) // for text editing the undo/redo buttons should be always available
            return true;

        const redo = this.props.redo;

        if (redo && redo.length > 0)
            return true;
        else
            return false;
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isPreviewButtonOver != nextState.isPreviewButtonOver || this.state.isAddButtonOver != nextState.isAddButtonOver || this.state.isUndoOver != nextState.isUndoOver || this.state.isRedoOver != nextState.isRedoOver || this.props.accordionWidth != newProps.accordionWidth || this.props.windowWidth != newProps.windowWidth || this.props.windowHeight != newProps.windowHeight || this.props.needsRefresh != newProps.needsRefresh || this.props.showVideoEditor != newProps.showVideoEditor || this.props.undo != newProps.undo || this.props.redo != newProps.redo || this.props.undo != newProps.undo || this.props.contextMode != newProps.contextMode || this.props.showAudioEditor != newProps.showAudioEditor || this.props.timelines != newProps.timelines)
            return true;
        else
            return false;
    },
    render() {
        const width = this.props.windowWidth - this.props.accordionWidth;
        var listHeight = properties.SLIDE_VIEWER_LIST_HEIGHT + properties.SLIDE_VIEWER_TOP_GAP;

        if (this.props.showAudioEditor)
            listHeight = listHeight + audioEditorUtils.getAudioEditorHeight();

        const height = properties.SLIDE_VIEWER_TOP_LINE_HEIGHT + listHeight + properties.SLIDE_VIEWER_BOTTOM_GAP;

        var display = 'block';

        if (this.props.showVideoEditor)
            display = 'none';

        var slideViewerStyle = {
            position: 'absolute',
            top: this.props.windowHeight - height,
            left: 0,
            width: width,
            height: height,
            background: properties.SLIDE_VIEWER_BACKGROUND,
            cursor: 'default',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            userDrag: 'none',
            display
        };

        if (this.props.contextMode == modeType.LINE_CONTEXT || this.props.contextMode == modeType.FREEHAND_CONTEXT || this.props.contextMode == modeType.ANIMATION_CONTEXT) {
            slideViewerStyle.pointerEvents = 'none';
            slideViewerStyle.opacity = 0.5;
        }

        const buttonsHolderStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: audioToolUtils.buttonsHolderWidth(),
            height: height
        };

        var iconColor;
        var borderColor;

        if (this.state.isPreviewButtonOver == true) {
            iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        }
        else {
            iconColor = 'black';
            borderColor = 'white';
        }

        const buttonsTopPadding = properties.BUTTONS_HOLDER_TOP_GAP;

        const previewStyle = {
            width: properties.SLIDE_VIEWER_BUTTON_WIDTH,
            height: properties.SLIDE_VIEWER_BUTTON_WIDTH,
            background: 'white',
            borderRadius: 50,
            position: 'absolute',
            left: audioToolUtils.buttonsHolderWidth() - properties.BUTTONS_HOLDER_LEFT_GAP - 2 * properties.SLIDE_VIEWER_BUTTON_WIDTH - properties.SLIDE_VIEWER_BUTTONS_GAP,
            top: buttonsTopPadding,
            borderColor: borderColor,
            borderWidth: 1,
            borderStyle: 'solid',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        var offset = 0;

        if (platformDetection.isChromeBook() == true)
            offset = 0;

        const previewIconStyle = {
            position: 'absolute',
            top: 12 + offset,
            left: 12,
            color: iconColor
        };

        if (this.state.isAddButtonOver == true) {
            iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        }
        else {
            iconColor = 'black';
            borderColor = 'white';
        }

        const addSlideStyle = {
            width: properties.SLIDE_VIEWER_BUTTON_WIDTH,
            height: properties.SLIDE_VIEWER_BUTTON_WIDTH,
            background: 'white',
            position: 'absolute',
            left: audioToolUtils.buttonsHolderWidth() - properties.BUTTONS_HOLDER_LEFT_GAP - properties.SLIDE_VIEWER_BUTTON_WIDTH,
            top: buttonsTopPadding,
            borderColor: borderColor,
            borderWidth: 1,
            borderStyle: 'solid',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        const addIconStyle = {
            position: 'absolute',
            top: 13 + offset,
            left: 14,
            color: iconColor
        };

        // undo style
        var opacity = 1;
        var tabIndexUndo;

        if (this.isUndoAvailable() == false) {
            iconColor = 'black';
            borderColor = 'white';
            opacity = 0.6;
            tabIndexUndo = '-1';
        } else {
            if (this.state.isUndoOver == true) {
                iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
                borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            }
            else {
                iconColor = 'black';
                borderColor = 'white';
            }
        }

        const undoStyle = {
            width: properties.SLIDE_VIEWER_BUTTON_WIDTH,
            height: properties.SLIDE_VIEWER_BUTTON_WIDTH,
            background: 'white',
            position: 'absolute',
            left: properties.BUTTONS_HOLDER_LEFT_GAP,
            top: buttonsTopPadding,
            borderColor: borderColor,
            borderWidth: 1,
            borderStyle: 'solid',
            borderRadius: 50,
            opacity: opacity,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        const undoIconStyle = {
            position: 'absolute',
            top: 13,
            left: 13,
            color: iconColor
        };

        // redo style
        var tabIndexRedo;

        if (this.isRedoAvailable() == false) {
            iconColor = 'black';
            borderColor = 'white';
            opacity = 0.6;
            tabIndexRedo = '-1';
        } else {
            opacity = 1;

            if (this.state.isRedoOver == true) {
                iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
                borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            }
            else {
                iconColor = 'black';
                borderColor = 'white';
            }
        }

        const redoStyle = {
            width: properties.SLIDE_VIEWER_BUTTON_WIDTH,
            height: properties.SLIDE_VIEWER_BUTTON_WIDTH,
            background: 'white',
            position: 'absolute',
            left: properties.BUTTONS_HOLDER_LEFT_GAP + properties.SLIDE_VIEWER_BUTTON_WIDTH + properties.SLIDE_VIEWER_BUTTONS_GAP,
            top: buttonsTopPadding,
            borderColor: borderColor,
            borderWidth: 1,
            borderStyle: 'solid',
            borderRadius: 50,
            opacity: opacity,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        const redoIconStyle = {
            position: 'absolute',
            top: 13,
            left: 13,
            color: iconColor
        };

        var element;

        if (this.props.showAudioEditor) {
            element = <AudioEditorControls dispatch={this.props.dispatch}/>;
        }

        return (
            <div ref="slideViewerWrapper" style={slideViewerStyle}>
                <div style={buttonsHolderStyle}>
                    <button ref="undo" aria-label={locales.getCaption('undo', 'hover')} tabIndex={tabIndexUndo} className='undoRedo' aria-disabled={tabIndexUndo == '-1' ? true : false} style={undoStyle} onTouchEnd={this.onUndo} onClick={this.onUndo} onMouseOver={this.onUndoMouseIn} onMouseOut={this.onUndoMouseOut}>
                        <i style={undoIconStyle} className="fa fa-undo undoRedo"></i>
                    </button>
                    <button ref="redo" aria-label={locales.getCaption('redo', 'hover')} tabIndex={tabIndexRedo} className='undoRedo' aria-disabled={tabIndexRedo == '-1' ? true : false} style={redoStyle} onTouchEnd={this.onRedo} onClick={this.onRedo} onMouseOver={this.onRedoMouseIn} onMouseOut={this.onRedoMouseOut}>
                        <i style={redoIconStyle} className="fa fa-repeat undoRedo"></i>
                    </button>
                    <button ref="preview" aria-label={locales.getCaption('preview', 'hover')} className="preview" style={previewStyle} onTouchEnd={this.changeMode} onClick={this.changeMode} onMouseOver={this.onPreviewButtonMouseIn} onMouseOut={this.onPreviewButtonMouseOut}>
                        <i style={previewIconStyle} className="fa fa-eye"></i>
                    </button>
                    <button ref="addSlide" aria-label={locales.getCaption('addSlide', 'hover')} style={addSlideStyle} onTouchEnd={this.addNewSlide} onClick={this.addNewSlide} onMouseOver={this.onAddButtonMouseIn} onMouseOut={this.onAddButtonMouseOut}>
                        <i style={addIconStyle} className="fa fa-plus"></i>
                    </button>

                    <MusicMenu dispatch={this.props.dispatch}/>
                </div>
                {element}
                <SlidesList listHeight={listHeight} dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} showAudioEditor={this.props.showAudioEditor}/>
                <SlideMenu dispatch={this.props.dispatch}/>
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    const timelines = state.audioEditor.timelines;
    const needsRefresh = state.slideViewer.needsRefresh;
    const undo = state.undoRedo.undo;
    const redo = state.undoRedo.redo;
    var accordionWidth = state.accordion.width;
    const contextMode = state.menu.contextMode;
    var showAudioEditor = state.menu.showAudioEditor;

    if (showAudioEditor == undefined)
        showAudioEditor = false;

    if (accordionWidth == undefined)
        accordionWidth = properties.BROWSER_WIDTH;

    return {
        needsRefresh,
        undo,
        redo,
        accordionWidth,
        contextMode,
        showAudioEditor,
        timelines
    };
}

export const SlideViewer = connect(mapStateToProps)(SlideViewerContent);



/** WEBPACK FOOTER **
 ** ./src/components/slideViewer/SlideViewer.js
 **/